<h2 mat-dialog-title i18n>My Units</h2>
<div mat-dialog-content>
  <div class="info-block">
    <p i18n>
      The "My Units" library contains curriculum units that you own or that have been shared with
      you by other WISE users.
    </p>
    <p i18n>
      Units that you create using the WISE Authoring Tool will appear here. Any units that you copy
      will also be listed here.
    </p>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close()" i18n>Close</button>
</div>
